<template>
	<div class="no-content-container">
		<!-- Nouveau message pour les questions flash -->
		<div v-if="isFlashQuestion" class="no-content-flash">
			<p class="no-content">
				Il n'y a actuellement aucun contenu pour ce niveau {{ computedLevelName }} en {{ computedSubjectName }}.
			</p>
			<p class="no-content">
				Mais vous pouvez générer en 2 min des questions flash avec l'IA et les modifier à votre guise !
			</p>
			<button @click="generateWithAI" class="button button--primary">
				✨ Générer avec l'IA
			</button>
		</div>
		
		<!-- Nouveau message pour les QCM -->
		<div v-else-if="isQCM" class="no-content-flash">
			<p class="no-content">
				Il n'y a actuellement aucun contenu pour ce niveau {{ computedLevelName }} en {{ computedSubjectName }}.
			</p>
			<p class="no-content">
				Mais vous pouvez générer en 2 min des QCM avec l'IA et les modifier à votre guise !
			</p>
			<button @click="generateWithAI" class="button button--primary">
				✨ Générer avec l'IA
			</button>
		</div>
		
		<!-- Message original pour les autres types de contenu -->
		<div v-else>
			<p class="no-content">
				Vous aurez accès à ces questions prochainement !
			</p>
			<p class="no-content">
				Vous êtes pressé(e) ? Appuyez sur le bouton pour secouer un peu
				l'équipe de création ...
			</p>
			<button @click="suggestion" class="whip">
				<img src="/img/whip.png" alt="" />

				<span v-if="correctlySend == null"> Plus vite que ca !</span>
				<span v-else-if="correctlySend">Envoyé !</span>
				<span v-else>Vous avez déjà secoué l'équipe</span>
			</button>
			<p class="no-content">
				Ou rejoignez notre équipe pour nous aider :
				<a href="mailto:contact@lecoinduprof.fr">contact@lecoinduprof.fr</a>
			</p>
		</div>
	</div>
</template>

<script>
import { createSuggestionService } from '../../../services/suggestionsService'

export default {
	props: {
		level: {
			type: [Number, String],
			required: false,
			validator(value) {
				// Accepter null, undefined, Number ou String qui peut être convertie en Number
				return value === null || value === undefined || value === '' || !isNaN(Number(value))
			}
		},
		chapter: {
			type: [Number, String],
			required: false,
			default: null,
			validator(value) {
				return value === null || value === undefined || value === '' || !isNaN(Number(value))
			}
		},
		type: {
			type: String,
			required: false,
		},
		subject: {
			type: [Number, String],
			required: false,
			default: null,
			validator(value) {
				return value === null || value === undefined || value === '' || !isNaN(Number(value))
			}
		},
		isFlashQuestion: {
			type: Boolean,
			default: false
		},
		isQCM: {
			type: Boolean,
			default: false
		},
		levelName: {
			type: String,
			default: ''
		},
		subjectName: {
			type: String,
			default: ''
		}
	},
	emits: ['openGenerateModal'],
	data() {
		return {
			correctlySend: null
		}
	},
	computed: {
		computedLevelName() {
			// Utiliser le prop levelName si fourni, sinon calculer à partir du store
			if (this.levelName) return this.levelName
			if (!this.level || this.level === '') return ''
			const levelId = Number(this.level)
			if (isNaN(levelId)) return ''
			const levelData = this.$store.getters.level(levelId)
			return levelData ? levelData.name : ''
		},
		computedSubjectName() {
			// Utiliser le prop subjectName si fourni, sinon calculer à partir du store
			if (this.subjectName) return this.subjectName
			if (!this.subject || this.subject === '') return ''
			const subjectId = Number(this.subject)
			if (isNaN(subjectId)) return ''
			const subjectData = this.$store.getters.subject(subjectId)
			return subjectData ? subjectData.name : ''
		}
	},
	methods: {
		generateWithAI() {
			// Transmettre les filtres actuels avec l'événement - convertir les strings vides en null
			const levelValue = this.level === '' ? null : (this.level ? Number(this.level) : null)
			const subjectValue = this.subject === '' ? null : (this.subject ? Number(this.subject) : null)
			const chapterValue = this.chapter === '' ? null : (this.chapter ? Number(this.chapter) : null)
			
			this.$emit('openGenerateModal', {
				level: levelValue,
				subject: subjectValue,
				chapter: chapterValue
			})
		},
		async suggestion() {
			const levelValue = this.level === '' ? null : (this.level ? Number(this.level) : null)
			const chapterValue = this.chapter === '' ? null : (this.chapter ? Number(this.chapter) : null)
			
			const suggestion = {
				user_id: this.$store.state.user.user,
				level_id: levelValue,
				chapter_id: chapterValue,
				type: this.type
			}

			const res = await createSuggestionService(suggestion)

			this.correctlySend = res.ok

		}
	},
}
</script>

<style scoped>
.no-content-flash {
	text-align: center;
}

.no-content-flash button {
	margin-top: 24px;
	display: inline-block;
}

.no-content-container {
	text-align: center;
}

.no-content-container button {
	margin: 20px auto;
	display: block;
}
</style>
